/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Active(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Active',
      'aria-hidden': true,
      focusable: false,
      width:  12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('circle', {"cx":"6","cy":"6","r":"1","fill":"currentColor"}),createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","d":"M2.095 1.444A5.99 5.99 0 0 0 0 6a5.99 5.99 0 0 0 2.095 4.556l.976-1.14A4.49 4.49 0 0 1 1.5 6a4.49 4.49 0 0 1 1.571-3.417zm6.834 1.14.976-1.14A5.99 5.99 0 0 1 12 6a5.99 5.99 0 0 1-2.095 4.556l-.976-1.14A4.49 4.49 0 0 0 10.5 6a4.49 4.49 0 0 0-1.571-3.417zm-5.207.759A3.5 3.5 0 0 0 2.5 6a3.49 3.49 0 0 0 1.222 2.657l.976-1.138A2 2 0 0 1 4 6c0-.607.27-1.152.698-1.519zm3.58 1.138.976-1.138A3.5 3.5 0 0 1 9.5 6a3.5 3.5 0 0 1-1.222 2.657L7.302 7.52a2 2 0 0 0 0-3.039","fill":"currentColor"}))
}
